export enum ProjectFormExecuteType {
  FORCE = 'FORCE',
  OPTIONAL = 'OPTIONAL',
  STOP = 'STOP',
}

export const ProjectFormExecuteTypeMap = {
  [ProjectFormExecuteType.FORCE]: '强制',
  [ProjectFormExecuteType.OPTIONAL]: '可选',
  [ProjectFormExecuteType.STOP]: '停用',
};

export const ProjectFormExecuteTypeList = [
  {
    value: ProjectFormExecuteType.FORCE,
    label: ProjectFormExecuteTypeMap[ProjectFormExecuteType.FORCE],
  },
  {
    value: ProjectFormExecuteType.OPTIONAL,
    label: ProjectFormExecuteTypeMap[ProjectFormExecuteType.OPTIONAL],
  },
  {
    value: ProjectFormExecuteType.STOP,
    label: ProjectFormExecuteTypeMap[ProjectFormExecuteType.STOP],
  },
];
